import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import { standardEmptyACC, standardFlowACC } from '../../utils/sagas';

import { FAILURE_REASON } from '../../constants/failureReasons';

import * as recordPayment from './recordPayment';
import * as submitSale from './submitSale';

const REQUESTED = '$FINALISE_ORDER/REQUESTED';
const BLOCKED = '$FINALISE_ORDER/BLOCKED';
const APPROVED = '$FINALISE_ORDER/APPROVED';
const SUCCEEDED = '$FINALISE_ORDER/SUCCEEDED';
const FAILED = '$FINALISE_ORDER/FAILED';

const request = <T>(type: T) => {
  return standardFlowACC<
    T,
    {
      authenticationMethod: AuthenticationMethod;
      subPayments: SubPayment[];
      paymentGatewayToken?: string;
      paymentGatewayPublicKey?: string;
      receiptType?: string;
    }
  >(type);
};

const succeed = <T>(type: T) => {
  return standardFlowACC<
    T,
    {
      subPayments: SubPayment[];
      saleDetails?: Sale;
      paymentGatewayClientSecret?: string;
    }
  >(type);
};

export type FailureReason =
  | undefined
  | recordPayment.FailureReason
  | FAILURE_REASON.PAYMENT_FAILED
  | submitSale.FailureReason
  | FAILURE_REASON.SALE_FAILED
  | FAILURE_REASON.UNVERIFIED_MEMBER;

const failed = <T>(type: T) => {
  return standardFlowACC<
    T,
    {
      error?: SerialisableException;
      reason: FailureReason;
      charged?: boolean;
      chargeStarted?: boolean;
      subPayments?: SubPayment[];
    }
  >(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, failed),
};

export default actions.requested;
